import { ReferralSourceVertical } from "store/slices/referral-source-report";
import { CrmMode } from "util/crm-mode";

export interface ReferralSourceVerticalView {
    showRevenue: boolean;
    movedLabel: string;
    moveRateLabel: string;
    avgDaysLabel: string;
    movedFootnote: string;
    avgDaysFootnote: string;
}

const VERTICAL_VIEWS: Record<ReferralSourceVertical, ReferralSourceVerticalView> = {
    placement: {
        showRevenue: true,
        movedLabel: "Moved",
        moveRateLabel: "Move Rate",
        avgDaysLabel: "Avg Days to Move",
        movedFootnote: "A client counts as moved when it has a move-in date set.",
        avgDaysFootnote:
            "Avg Days to Move is calculated from the client created date to the move-in date.",
    },
    homeCare: {
        showRevenue: false,
        movedLabel: "Started",
        moveRateLabel: "Start Rate",
        avgDaysLabel: "Avg Days to Start",
        movedFootnote: "A client counts as started when it has a Start of Care date set.",
        avgDaysFootnote:
            "Avg Days to Start is calculated from the client created date to the Start of Care date.",
    },
    all: {
        showRevenue: true,
        movedLabel: "Moved",
        moveRateLabel: "Move Rate",
        avgDaysLabel: "Avg Days to Move",
        movedFootnote:
            "A client counts as converted when it has a move-in date (placement) or Start of Care date (home care) set.",
        avgDaysFootnote:
            "Avg Days to Move is calculated from the client created date to the move-in or Start of Care date.",
    },
};

export const resolveEffectiveVertical = (
    mode: CrmMode,
    selected: ReferralSourceVertical,
): ReferralSourceVertical => {
    if (mode === "combined") {
        return selected;
    }
    if (mode === "home-care-only") {
        return "homeCare";
    }
    return "placement";
};

export const referralSourceVerticalView = (
    vertical: ReferralSourceVertical,
): ReferralSourceVerticalView => VERTICAL_VIEWS[vertical];
